export default __webpack_public_path__ + "static/MovieScreen-847b689ffb08737f1fb490823dab304c.png";